<script>
	import { onMount } from 'svelte';
	
	export let div;
	
	onMount(() => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = 'https://unpkg.com/mapbox-gl-compare@0.4.0/dist/mapbox-gl-compare.css';
		document.head.appendChild(link);

		return () => {
			link.parentNode.removeChild(link);
		};
	});
</script>

<div bind:this={div}>
	<slot></slot>
</div>